import React, { useEffect, useState } from "react";
import { useFetchData } from "../../hooks/useFetchData";
import Cardd from "../../ui/Card";
import { TestLanguage } from "../../hooks/testLanguage";
import { FaRegEdit } from "react-icons/fa";
import { MdSubtitles } from "react-icons/md";
import {
  QueryClient,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  Backdrop,
  Box,
  Button,
  Drawer,
  Fade,
  Grid,
  Modal,
  Select,
  Tab,
  Tooltip,
  Typography,
} from "@mui/material";
import { CiEraser } from "react-icons/ci";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";



import { FaEraser } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { FaBuildingUser } from "react-icons/fa6";
import { BsFillBuildingsFill } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Subtable from "../../ui/Subtable";
import Submodal from "../../ui/submodal";
import Drawer2 from "../../Pages/Project/Drawer2";



const Management = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { data } = useFetchData(`${process.env.REACT_APP_API_URL}developers`);
  const { data: data3 } = useFetchData(`${process.env.REACT_APP_API_URL}cars`);
  const { data: data4 } = useFetchData(`${process.env.REACT_APP_API_URL}projects`);
  const { data: data2 } = useFetchData(`${process.env.REACT_APP_API_URL}getsubscribers`);
  console.log("data222", data2);

  const closeModal = () => {
    setModalIsOpen(false);
  };
  console.log("developer", data);
  const navigate = useNavigate()
  const [selectedPoint, setSelectedPoint] = useState(null);
  const [selectedPoint2, setSelectedPoint2] = useState(null);
  const [value, setValue] = React.useState("1");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [iddeleted, setIddeleted] = useState();
  const [open, setOpen] = React.useState(false);
  const [openmodal, setOpenmodal] = React.useState(false);
  /////////////////////////////////////////////////
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  //////////////////////////////////////////////////////
  const handleClose = () => setOpen(false);
  const handleChange2 = (event, newValue) => {
    setValue(newValue);
  };
   const location = useLocation();

  const openModal = (data) => {
    console.log("data", data);

    setSelectedPoint(data);
    console.log("setSelectedPoint",data);
    
    setModalIsOpen(true);
    console.log("data", data);
  };

  const handleOpen = (id) => {
    setIddeleted(id);
    console.log("ggg", id);

    setOpen(true);
  };
  const handleSend = () => {
    async function deletePost() {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}developers/${iddeleted}`
        );
        console.log(response);
        toast.success("deleted successfully");
        setOpen(false);
        queryClient.invalidateQueries(["posts", iddeleted]);
      } catch (error) {
        console.error(error);
      }
    }
    deletePost();
  };

  // const handleSendcar = () => {
  //   async function deletePost() {
  //     try {
  //       const response = await axios.delete(
  //         `${process.env.REACT_APP_API_URL}cars/${iddeleted}`
  //       );
  //       console.log(response);
  //       toast.success("deleted successfully");
  //       setOpen(false);
  //       queryClient.invalidateQueries(["posts", iddeleted]);
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   }
  //   deletePost();
  // };

  // const unapprove = async (data) => {
  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URL}changepoststatus`,
  //       {
  //         post_id: data.id,
  //         status: "5",
  //       }
  //     );
  //     console.log(response);
  //     queryClient.invalidateQueries([`${process.env.REACT_APP_API_URL}units`]);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const approve = async (data) => {
  //   try {
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_URL}changepoststatus`,
  //       {
  //         post_id: data.id,
  //         status: "4",
  //       }
  //     );
  //     queryClient.invalidateQueries([`${process.env.REACT_APP_API_URL}units`]);
  //     console.log(response);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  return (
    <Box className="container" sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange2} aria-label="lab API tabs example">
            <Tab
              sx={{ fontFamily: "oswald,cairo", fontSize: "16px" }}
              icon={<FaBuildingUser size={24} />}
              label={t("nav.developer")}
              value="1"
            />
            <Tab
              sx={{ fontFamily: "oswald,cairo", fontSize: "16px" }}
              icon={<BsFillBuildingsFill size={24} />}
              label={t("nav.project")}
              value="2"
            />
            <Tab
              sx={{ fontFamily: "oswald,cairo", fontSize: "16px" }}
              icon={<MdSubtitles size={24} />}
              label={t("nav.subscription")}
              value="3"
            />
          </TabList>
        </Box>
        <TabPanel value="1">
          {" "}
          {(data?.data || []).map((i, index) => (
            <div
              style={{ textAlign: "center", margin: "30px 0px" }}
              className="col-md-3 col-sm-6"
              key={i?.id || index}
              size={6}
            >
              <div>
                <div
                  style={{
                    height: "50px",
                    backgroundColor:
                      "#f5f5f5",
                    borderRadius: "5px 5px 0 0 ",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingLeft: "8px",
                    alignItems: "center",
                    color: "#000",
                  }}
                >
                  <div
                    className="row"
                    style={{
                      justifyContent: "space-evenly",
                      textAlign: "center",
                    }}
                  >

                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.edit")}
                          </span>
                        }
                      >
                        <FaRegEdit
                          style={{ cursor: "pointer" }}
                          size={24}
                          onClick={() => navigate(`/developer/${i?.id}`)}
                        />
                      </Tooltip>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.delete")}
                          </span>
                        }
                      >
                        <FaEraser
                          style={{ cursor: "pointer" }}
                          size={24}
                          onClick={() => handleOpen(i?.id)}
                        />
                      </Tooltip>
                    </div>
                  </div>

                  <h5 style={{ padding: "8px", margin: "0" }}>
                    {TestLanguage(i?.post?.status, "developer_name")}
                  </h5>
                </div>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  open={open}
                  onClose={handleClose}
                  closeAfterTransition
                  slots={{ backdrop: Backdrop }}
                  slotProps={{
                    backdrop: {
                      timeout: 500,
                    },
                  }}
                >
                  <Fade in={open}>
                    <Box sx={style}>
                      <Typography
                        id="transition-modal-title"
                        variant="h4"
                        component="h2"
                      >
                        are you sure for delete this post???
                      </Typography>
                      <div
                        style={{
                          marginTop: "50px",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          sx={{ margin: "5px" }}
                          onClick={handleSend}
                        >
                          ok
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          sx={{ margin: "5px" }}
                          onClick={handleClose}
                        >
                          no
                        </Button>
                      </div>
                    </Box>
                  </Fade>
                </Modal>
              </div>
              <Link  to={`projectofdeveloper/${i.id}`}>
                <Cardd data={i} />
              </Link>
            </div>
          ))}
          {/* {selectedPoint && (
            <Drawermangment
            selectedPoint={selectedPoint}
              point={selectedPoint?.id}
              isOpen={modalIsOpen}
              onClose={closeModal}
            
            >
              <h2>{selectedPoint?.project_name}</h2>
                                   <p>{selectedPoint?.description}</p>
              <h2>{TestLanguage(selectedPoint, "project_name")}</h2>
              <h2>{TestLanguage(selectedPoint, "name")}</h2>
              <p>{TestLanguage(selectedPoint, "description")}</p>
            </Drawermangment>
          )} */}
        </TabPanel>
        <TabPanel value="2">
          {" "}
          {(data4?.data || []).map((i, index) => (
            <div
              style={{ textAlign: "center", margin: "30px 0px" }}
              className="col-md-3
                             col-sm-6"
              key={i?.id || index}
              size={6}
            >
              <div>
                <div
                  style={{
                    height: "50px",
                    backgroundColor:
                      "#f5f5f5",
                    borderRadius: "5px 5px 0 0 ",
                    display: "flex",
                    justifyContent: "space-between",
                    paddingLeft: "8px",
                    alignItems: "center",
                    color: "#000",
                  }}
                >
                  <div
                    className="row"
                    style={{
                      justifyContent: "space-evenly",
                      textAlign: "center",
                    }}
                  >

                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.edit")}
                          </span>
                        }
                      >
                        <FaRegEdit
                          style={{ cursor: "pointer" }}
                          size={24}
                          onClick={() => navigate(`/project/${i?.id}`)}
                        />
                      </Tooltip>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <Tooltip
                        title={
                          <span style={{ fontSize: "15px" }}>
                            {t("drawerUnit.delete")}
                          </span>
                        }
                      >
                        <FaEraser
                          style={{ cursor: "pointer" }}
                          size={24}
                          onClick={() => handleOpen(i?.id)}
                        />
                      </Tooltip>
                    </div>
                  </div>

                  <h5 style={{ padding: "8px", margin: "0" }}>
                    {TestLanguage(i?.post?.status, "datadeveloper_name")}
                  </h5>
                </div>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  open={open}
                  onClose={handleClose}
                  closeAfterTransition
                  slots={{ backdrop: Backdrop }}
                  slotProps={{
                    backdrop: {
                      timeout: 500,
                    },
                  }}
                >
                  <Fade in={open}>
                    <Box sx={style}>
                      <Typography
                        id="transition-modal-title"
                        variant="h4"
                        component="h2"
                      >
                        are you sure for delete this post???
                      </Typography>
                      <div
                        style={{
                          marginTop: "50px",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          sx={{ margin: "5px" }}
                          onClick={handleSend}
                        >
                          ok
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          sx={{ margin: "5px" }}
                          onClick={handleClose}
                        >
                          no
                        </Button>
                      </div>
                    </Box>
                  </Fade>
                </Modal>
              </div>
              <span onClick={() => openModal(i)}>
                <Cardd data={i} />
              </span>
            </div>
          ))}
          {selectedPoint && (
            <Drawer2
              point={selectedPoint?.id}
              isOpen={modalIsOpen}
              onClose={closeModal}
              selectedPoint={selectedPoint}
            >
              {/* <h2>{selectedPoint?.name}</h2>
                                   <p>{selectedPoint?.description}</p> */}
              <h2>{TestLanguage(selectedPoint?.offertype, "name")}</h2>
              <h2>{TestLanguage(selectedPoint, "name")}</h2>
              <p>{TestLanguage(selectedPoint, "description")}</p>
            </Drawer2>
          )}
        </TabPanel>     
        <TabPanel value="3">
          {" "}
          <Subtable rows={data2?.data} />
          <Grid container>
            <Grid size={9}></Grid>
            <Grid size={2} style={{ marginTop: "20px" }}>
            <Submodal open={openmodal} setOpen={setOpenmodal} />
            </Grid>
          </Grid>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Management;
